import { SHIPPING_UNIT_LIST_COLUMN } from "./actionTypes";

const INIT_STATE = {
  // List Shipping
  list: {
    // items: [],
    // totalCount: 0,
    columnsVisible: {},
    // params: {
    //   sizePerPage: 10,
    //   page: 1,
    //   sort: "-maker_date",
    //   columnFilter: {}, // Column filter
    //   keywords: "", // Input search all
    // },
  },
  loadingList: false,
  errorList: null,

  // // Create Job Title
  // create: null,
  // loadingCreate: false,
  // errorCreate: null,

  // // Detail Job Title
  // detail: null,
  // loadingDetail: false,
  // errorDetail: null,

  // // Update Job Title
  // update: null,
  // loadingUpdate: false,
  // errorUpdate: null,

  // // Delete Job Title
  // delete: null,
  // loadingDelete: false,
  // errorDelete: false,

  // // Active Job Title
  // active: null,
  // loadingActive: false,
  // errorActive: null,
};

const shippingUnit = (state = INIT_STATE, action) => {
  switch (action.type) {
    // List Job Title
    // case JOB_TITLE_LIST:
    //   return {
    //     ...state,
    //     loadingList: true,
    //     errorList: null,
    //   };
    // case JOB_TITLE_LIST_SUCCESS:
    //   return {
    //     ...state,
    //     errorList: null,
    //     loadingList: false,
    //     list: {
    //       ...state.list,
    //       items: action.payload.items,
    //       totalCount: action.payload._meta
    //         ? action.payload._meta.totalCount
    //         : action.payload.items.length,
    //     },
    //   };
    // case JOB_TITLE_LIST_FAIL:
    //   return { ...state, loadingList: false, errorList: action.payload };
    // case JOB_TITLE_LIST_RESET:
    //   return {
    //     ...state,
    //     loadingList: false,
    //     errorList: null,
    //     list: {
    //       ...state.list, // columnsVisible
    //       items: [],
    //       totalCount: 0,
    //       params: {
    //         sizePerPage: 10,
    //         page: 1,
    //         sort: "-maker_date",
    //         columnFilter: {},
    //         keywords: "",
    //       },
    //     },
    //   };
    case SHIPPING_UNIT_LIST_COLUMN:
      const currentColumns = state.list.columnsVisible || {};
      currentColumns[action.payload.field] = action.payload.value;
      return {
        ...state,
        list: { ...state.list, columnsVisible: currentColumns },
      };

    // // Create Job Title
    // case JOB_TITLE_CREATE:
    //   return {
    //     ...state,
    //     loadingCreate: true,
    //     errorCreate: null,
    //   };
    // case JOB_TITLE_CREATE_SUCCESS:
    //   return {
    //     ...state,
    //     loadingCreate: false,
    //     errorCreate: null,
    //     create: { ...action.payload, success: true },
    //   };
    // case JOB_TITLE_CREATE_FAIL:
    //   return { ...state, loadingCreate: false, errorCreate: action.payload };
    // case JOB_TITLE_CREATE_RESET:
    //   return {
    //     ...state,
    //     loadingCreate: false,
    //     errorCreate: null,
    //     create: null,
    //   };

    // // Detail Job Title
    // case JOB_TITLE_DETAIL:
    //   return {
    //     ...state,
    //     loadingDetail: true,
    //     errorDetail: null,
    //   };
    // case JOB_TITLE_DETAIL_SUCCESS:
    //   return {
    //     ...state,
    //     loadingDetail: false,
    //     errorDetail: null,
    //     detail: { ...action.payload, success: true },
    //   };
    // case JOB_TITLE_DETAIL_FAIL:
    //   return { ...state, loadingDetail: false, errorDetail: action.payload };
    // case JOB_TITLE_DETAIL_RESET:
    //   return {
    //     ...state,
    //     loadingDetail: false,
    //     errorDetail: null,
    //     detail: null,
    //   };

    // // Update Job Title
    // case JOB_TITLE_UPDATE:
    //   return {
    //     ...state,
    //     loadingUpdate: true,
    //     errorUpdate: null,
    //   };
    // case JOB_TITLE_UPDATE_SUCCESS:
    //   return {
    //     ...state,
    //     loadingUpdate: false,
    //     errorUpdate: null,
    //     update: { ...action.payload, success: true },
    //   };
    // case JOB_TITLE_UPDATE_FAIL:
    //   return { ...state, loadingUpdate: false, errorUpdate: action.payload };
    // case JOB_TITLE_UPDATE_RESET:
    //   return {
    //     ...state,
    //     loadingUpdate: false,
    //     errorUpdate: null,
    //     update: null,
    //   };

    // // Delete Job Title
    // case JOB_TITLE_DELETE:
    //   return {
    //     ...state,
    //     loadingDelete: true,
    //     errorDelete: null,
    //   };
    // case JOB_TITLE_DELETE_SUCCESS:
    //   return {
    //     ...state,
    //     loadingDelete: false,
    //     errorDelete: null,
    //     delete: { success: true },
    //   };
    // case JOB_TITLE_DELETE_FAIL:
    //   return { ...state, loadingDelete: false, errorDelete: action.payload };
    // case JOB_TITLE_DELETE_RESET:
    //   return {
    //     ...state,
    //     loadingDelete: false,
    //     errorDelete: null,
    //     delete: null,
    //   };

    // // Active Job Title
    // case JOB_TITLE_ACTIVE:
    //   return {
    //     ...state,
    //     loadingActive: true,
    //     errorActive: null,
    //   };
    // case JOB_TITLE_ACTIVE_SUCCESS:
    //   return {
    //     ...state,
    //     loadingActive: false,
    //     errorActive: null,
    //     active: { ...action.payload, success: true },
    //   };
    // case JOB_TITLE_ACTIVE_FAIL:
    //   return {
    //     ...state,
    //     loadingActive: false,
    //     errorActive: action.payload,
    //   };
    // case JOB_TITLE_ACTIVE_RESET:
    //   return {
    //     ...state,
    //     loadingActive: false,
    //     errorActive: null,
    //     active: null,
    //   };

    default:
      return state;
  }
};

export default shippingUnit;
